var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingCwc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#effbf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "stay-at-home",
    transform: "translate(479.621 193.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9932",
    "data-name": "Path 9932",
    d: "M16.828,19.4a6.4,6.4,0,0,0,2.906,5.356A8.236,8.236,0,0,0,15,32.194v4.57a.917.917,0,0,0,.914.914H30.538a.917.917,0,0,0,.914-.914v-4.57a8.236,8.236,0,0,0-4.734-7.44A6.4,6.4,0,1,0,16.828,19.4Zm12.8,12.8V35.85h-12.8V32.194a6.4,6.4,0,0,1,12.8,0ZM27.8,19.4a4.57,4.57,0,1,1-4.57-4.57A4.572,4.572,0,0,1,27.8,19.4Z",
    transform: "translate(-1.033 -0.774)",
    fill: "#23c55e",
    stroke: "#23c55e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9933",
    "data-name": "Path 9933",
    d: "M22.76,4.2a.92.92,0,0,0-1.142,0L3.338,18.825A.917.917,0,1,0,4.48,20.26l.347-.283V39.646a.917.917,0,0,0,.914.914h32.9a.917.917,0,0,0,.914-.914V19.977l.347.274a.878.878,0,0,0,.567.2.913.913,0,0,0,.713-.347.925.925,0,0,0-.146-1.289Zm14.971,34.53H6.655V18.514L22.193,6.084l15.538,12.43Z",
    transform: "translate(0 0)",
    fill: "#23c55e",
    stroke: "#23c55e",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingCwc);
export default __webpack_public_path__ + "static/media/setting-cwc.3619ea7441901e363a97274615e48f9e.svg";
export { ForwardRef as ReactComponent };